// extracted by mini-css-extract-plugin
export default {"root":"IconVideoFile_root__mmMdg"};